<template>
  <BMDialog
    showDialog
    :headerText="$t('mainNavigation.selectLanguage')"
    :showFooter="false"
    :fullscreen="false"
    :minHeight="xs ? '80vh' : '75vh'"
    :maxHeight="xs ? '85vh' : '80vh'"
    :width="xs ? '85vw' : undefined"
    hideSubmitButton
    dialogTestId="language-dialog"
    @closed="closeDialog"
  >
    <template #appendHeader>
      <v-text-field
        v-model="searchText"
        :label="$t('generic.search')"
        variant="outlined"
        prependInnerIcon="$search"
        hideDetails
        clearable
        name="language-search"
        data-cc="search-language"
      />
    </template>

    <v-list
      class="pa-0"
      color="primary"
      density="comfortable"
      :variant="isDarkMode ? 'flat' : 'text'"
    >
      <v-list-item
        v-for="{ name, short } in filteredLanguages"
        :key="short"
        :active="short === language"
        :data-item="short"
        rounded
        data-cc="select-language"
        @click="onLanguageClick(short)"
      >
        <v-list-item-title data-cc="nav-menu-language-item">
          {{ name }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </BMDialog>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useDisplay } from 'vuetify';

import { useLanguageSelector } from '@/composables/useLanguageSelector';
import { useAppTheme } from '@/composables/useAppTheme';

import BMDialog from '@/components/common/utilities/BMDialog.vue';

const { xs } = useDisplay();
const { isDarkMode } = useAppTheme();

const searchText = ref('');

// Emits
const emit = defineEmits(['close']);

// Language selection block
const { language, supportedLanguages, selectLanguage } = useLanguageSelector();

const closeDialog = () => emit('close');

const onLanguageClick = async (newLocale) => {
  await selectLanguage(newLocale);
  closeDialog();
};

// Search the supported languages and find matches
const filteredLanguages = computed(() => {
  const search = searchText.value?.toLowerCase().trim();

  // If the search is empty, return the full list
  if (!search) {
    return supportedLanguages;
  }

  // Filter based on language name, short code, or display name
  return supportedLanguages.filter(
    (lang) =>
      lang.name?.toLowerCase().includes(search) ||
      lang.short?.toLowerCase().includes(search) ||
      lang.display?.toLowerCase().includes(search)
  );
});
</script>
